import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-associate-confirmation-dialog',
  templateUrl: './associate-confirmation-dialog.component.html',
  styleUrls: ['./associate-confirmation-dialog.component.scss']
})
export class AssociateConfirmationDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<AssociateConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onDefaultCustomer(): void {
    this.dialogRef.close('default');
  }

  onFillDetailsLater(): void {
    this.dialogRef.close('later');
  }

  onCancel(): void {
    this.dialogRef.close('cancel');
  }
} 